/* LD · Carrito lateral estilo ADOR */
(function () {
  var SECTION = 'ld-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class LdCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.timers = {};
      if (this.parentElement !== document.body) document.body.appendChild(this);

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-ldcd-close]')) { e.preventDefault(); self.close(); return; }
        var q = e.target.closest('[data-ldcd-qty]');
        if (q) {
          var item = q.closest('.ldCD__item');
          var input = item.querySelector('[data-ldcd-input]');
          var v = (parseInt(input.value, 10) || 0) + (q.dataset.ldcdQty === 'plus' ? 1 : -1);
          v = Math.max(0, v);
          input.value = v;
          self.queue(item, v);
          return;
        }
        var rm = e.target.closest('[data-ldcd-remove]');
        if (rm) { self.change(rm.closest('.ldCD__item'), 0); return; }
      });
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-ldcd-input]');
        if (!input) return;
        var v = Math.max(0, parseInt(input.value, 10) || 0);
        self.change(input.closest('.ldCD__item'), v);
      });
      this.addEventListener('submit', function (e) {
        var b = e.target.querySelector('[data-ldcd-checkout]');
        if (b) b.setAttribute('aria-busy', 'true');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
      });
      /* Icono del carrito de la cabecera -> abre el carrito lateral (como ADOR) */
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || self.contains(a)) return;
        var href = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
        if (!/(^|\/)cart$/.test(href)) return;
        if (!a.closest('header, #header-group, .header-actions, [data-ldcd-open]')) return;
        if (/\/cart\/?$/.test(window.location.pathname)) return;
        e.preventDefault();
        self.open(true);
      }, true);
      /* "Cantidad (1 en el carrito)" en la ficha, como ADOR */
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-ldp-option] [data-value]')) setTimeout(function () { self.syncLabel(); }, 0);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
      document.addEventListener('ld:cart:added', function () { self.refresh().then(function () { self.open(); }); });
      this.syncLabel();
      this.syncFsb();
    }

    /* Barra superior de envio gratis dinamica (como ADOR) */
    syncFsb() {
      var tpl = this.querySelector('[data-ldcd-fsb]');
      var p = document.querySelector("[id$='__header_announcements_Qh7EEH'] .announcement-bar__text");
      if (!tpl || !p) return;
      if (p.dataset.ldBase === undefined) p.dataset.ldBase = p.innerHTML;
      var state = tpl.dataset.state;
      p.dataset.ldState = state;
      p.dataset.ldUrl = tpl.dataset.url || '';
      if (state === 'away' || state === 'done') p.innerHTML = tpl.innerHTML.trim();
      else p.innerHTML = p.dataset.ldBase;
      p.style.cursor = state === 'away' ? 'pointer' : '';
      if (!p._ldClick) {
        p._ldClick = true;
        p.addEventListener('click', function () {
          if (p.dataset.ldState === 'away' && p.dataset.ldUrl) window.location.href = p.dataset.ldUrl;
        });
      }
    }

    syncLabel() {
      var inner = this.querySelector('[data-ldcd-inner]');
      if (!inner) return;
      var map = {};
      var mapEl = inner.querySelector('[data-ldcd-map]');
      try { map = JSON.parse(mapEl ? mapEl.textContent : '{}'); } catch (e) { map = {}; }
      var txt = inner.dataset.incart || '';
      document.querySelectorAll('ld-ador-product').forEach(function (p) {
        var lbl = p.querySelector('.ldP-qty-label');
        var id = p.querySelector('[data-ldp-form] input[name="id"]');
        if (!lbl || !id) return;
        if (lbl.dataset.base === undefined) lbl.dataset.base = lbl.textContent.trim();
        var n = map[id.value] || 0;
        lbl.textContent = lbl.dataset.base + (n > 0 ? ' (' + n + ' ' + txt + ')' : '');
      });
    }

    open(refresh) {
      this._last = document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('ldCD-lock');
      var inner = this.querySelector('[data-ldcd-inner]');
      setTimeout(function () { if (inner) inner.focus({ preventScroll: true }); }, 50);
      if (refresh) this.refresh();
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('ldCD-lock');
      if (this._last && this._last.focus) this._last.focus({ preventScroll: true });
    }

    render(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ldcd-inner]');
      var inner = this.querySelector('[data-ldcd-inner]');
      if (!fresh || !inner) return;
      var sc = inner.querySelector('.ldCD__contents');
      var top = sc ? sc.scrollTop : 0;
      inner.innerHTML = fresh.innerHTML;
      var count = parseInt(fresh.dataset.count, 10) || 0;
      this.classList.toggle('is-empty', count === 0);
      var nsc = inner.querySelector('.ldCD__contents');
      if (nsc) nsc.scrollTop = top;
      this.updateBubble(count);
      this.syncLabel();
      this.syncFsb();
    }

    updateBubble(count) {
      document.querySelectorAll('cart-icon').forEach(function (c) {
        if (typeof c.renderCartBubble === 'function') c.renderCartBubble(count, false);
      });
    }

    refresh() {
      var self = this;
      return fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { self.render(j[SECTION]); })
        .catch(function () {});
    }

    queue(item, qty) {
      var self = this;
      var key = item.dataset.key;
      clearTimeout(this.timers[key]);
      this.timers[key] = setTimeout(function () { self.change(item, qty); }, 350);
    }

    change(item, qty) {
      var self = this;
      if (!item) return;
      clearTimeout(this.timers[item.dataset.key]);
      item.classList.add('is-loading');
      var err = item.querySelector('[data-ldcd-err]');
      if (err) err.textContent = '';
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: qty, sections: [SECTION], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            item.classList.remove('is-loading');
            if (err) err.textContent = res.j.description || res.j.message || '';
            return self.refresh().then(function () {
              var again = self.querySelector('.ldCD__item[data-key="' + item.dataset.key + '"] [data-ldcd-err]');
              if (again) again.textContent = res.j.description || res.j.message || '';
            });
          }
          if (res.j.sections && res.j.sections[SECTION]) self.render(res.j.sections[SECTION]);
          else return self.refresh();
          document.dispatchEvent(new CustomEvent('ld:cart:changed', { detail: res.j }));
        })
        .catch(function () { item.classList.remove('is-loading'); });
    }
  }

  if (!customElements.get('ld-cart-drawer')) customElements.define('ld-cart-drawer', LdCartDrawer);

  window.LDCart = {
    el: function () { return document.querySelector('ld-cart-drawer'); },
    open: function (refresh) { var d = this.el(); if (d) d.open(refresh); return !!d; },
    refresh: function () { var d = this.el(); return d ? d.refresh() : Promise.resolve(); },
    added: function () { var d = this.el(); if (!d) return false; d.refresh().then(function () { d.open(); }); return true; }
  };
})();
